import React from 'react'
import type { InventoryBySerialNumber, Product } from '@ztechapps/common.contract'
import { NumberInput } from '@ztechapps/webui.input'
import toNumber from 'lodash/toNumber'
import { InputGroup } from 'react-bootstrap'
import { InventoryBySerialNumberModal } from './InventoryBySerialNumberModal'

export type InventoryBySerialNumberValue = {
  quantity: number
  inventoryBySerialNumbers: InventoryBySerialNumber[]
  product: Product
  _id?: string
}
export type InventoryBySerialNumberInputProps = {
  disabled?: boolean
  value: InventoryBySerialNumberValue
  onChange: (value: InventoryBySerialNumberValue) => Promise<void>
}
export function InventoryBySerialNumberInput({ value, onChange, disabled }: InventoryBySerialNumberInputProps) {
  const { quantity } = value ?? {}

  async function onChangeQuantity(e) {
    const inputValue = toNumber(e?.target?.value ?? '')

    await onChange({ ...value, quantity: inputValue })
  }

  return (
    <InputGroup>
      <NumberInput disabled={disabled} value={quantity} onChange={onChangeQuantity} />

      <InventoryBySerialNumberModal disabled={disabled || quantity === 0} value={value} onChange={onChange} />
    </InputGroup>
  )
}
